import { get, last, find } from 'lodash'
import getEmojiForCategory from 'utils/getEmojiForCategory'
import { numberGroup } from 'utils/format'
import { adLocationPreposition } from 'utils/locationPreposition'
import { GO_TO_PARTNERS } from './constants'

export const AD_TYPE_DEFAULT = 'default'
export const AD_TYPE_MOTOR = 'motor'
export const AD_TYPE_REAL_ESTATE = 'real_estate'

export const shouldLinkAdToInfoPage = (ad) =>
  GO_TO_PARTNERS.includes(get(ad, 'partnerInfo.name')) && get(ad, 'infopage.url')

export const getMetaDescriptionText = (price, location, category, body, subAds) => {
  const priceText = price ? `${price.value} ${price.suffix}` : null
  const locationText = last(location).id !== '99' ? last(location).name : null
  const categoryText = last(category).name
  const emoji = getEmojiForCategory(last(category).id)
  let bodyText

  if (body) {
    bodyText = body.replace(/\n+/g, ' ')
  } else if (subAds) {
    bodyText = subAds.map((subAd) => subAd.subject).join(' - ')
  }

  const descriptionText = [emoji, priceText, categoryText, locationText, bodyText]
    .filter((e) => e)
    .join(' - ')

  if (descriptionText.length >= 160) {
    return `${descriptionText.slice(0, 157).replace(/.\s*$/, '')}...`
  }

  return descriptionText
}

export const getPrioritizedNameFromLocation = (location) => {
  const existingParam =
    find(location, ['queryKey', 'm']) ||
    find(location, ['queryKey', 'r']) ||
    find(location, ['queryKey', 'co']) ||
    {}

  return existingParam.name
}

export const getFormattedPrice = (price) =>
  price && price.value !== 0 && `${numberGroup(price.value)} ${price.suffix}`

export const getFormattedPriceWithoutVat = (price) =>
  price &&
  price.valueWithoutVat &&
  `(${numberGroup(price.valueWithoutVat)} ${price.suffix} ex. moms)`

export const getFormattedOldPrice = (price) =>
  price && price.priceLowered && `${numberGroup(price.oldValue)} ${price.suffix}`

export const getArea = (location) => last(location).name

export const getAdType = (ad) => {
  const types = {
    default: AD_TYPE_DEFAULT,
    1000: AD_TYPE_MOTOR,
    3000: AD_TYPE_REAL_ESTATE,
  }

  let adType = types.default
  if (ad) {
    ad.category.forEach(({ id }) => {
      if (types[id]) {
        adType = types[id]
      }
    })
  }

  return adType
}

const _adTypeText = {
  s: 'säljes',
  k: 'köpes',
  u: 'uthyres',
}

export const adTypeToText = (type) => _adTypeText[type] || ''

export const getAdTitle = (subject, type, location) => {
  const locationName = getPrioritizedNameFromLocation(location)
  return `${subject} ${adTypeToText(type)} ${adLocationPreposition(locationName)}- Blocket`
}
